import SideBar from "../components/SideBar/SideBarPatient";
import "./styles-layout-doctor.scss";

const LayoutPatient = ({ children }) => {
  return (
    <div className="layout-doctor flex">
      <SideBar />
      <div className="w-full pl-4">{children}</div>
    </div>
  );
};

export default LayoutPatient;
